<template>
   <div class="bg-white mx-[5%] my-2">
    <div class="flex w-full border border-gray-300 bg-gray-100 rounded-lg overflow-hidden" @click="navigate">
      <div class="w-1/3 flex justify-center items-center">
        <img :src="imageSrc" alt="" class="object-contain max-h-[200px] mx-auto my-auto">
      </div>
      <div class="w-2/3 flex flex-col justify-center p-4 text-gray-800">
        <div class="text-center">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imageSrc: String,
    text: String,
    to: String,
  },
   methods: {
    navigate() {
      if (this.to) {
        this.$router.push(this.to);

      }
    },
  },
}
</script>